module.exports = __webpack_public_path__ + "media/wood_2.62dcb393.mp3";